import * as React from 'react'
import {useTranslation} from 'react-i18next'
import DatePickerV2 from '../../../components/DatePickerV2/DatePickerV2'
import {Selection} from '../../../components/Selection'
import {TRowFilter} from '../../../components/Table/Table'
import {TextInputV2} from '../../../components/TextInputV2'
import {
  CONTRACT_STATUS,
  PAYMENT_TYPE,
  PRODUCT_TYPE,
  REGARDING_OPTIONS,
  SECTOR_OPTIONS,
} from '../../../constants'
import {useSalesOrganization} from '../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {filterSelector, setFilterContracts} from '../../../redux/slices/filterSlices'
import { hasFilterProps } from './helpers'

interface RowFilterProps {
  // role?: 'admin' | 'null' | 'salesAnper' | 'salesAdmin' | 'otorisator' | 'finance'
  role?: string
}

export const RowFilter: React.FC<RowFilterProps> = (props) => {
  const {t} = useTranslation()
  const {role} = props

  const isNullRole = role === 'null'
  const {salesOrgOptions} = useSalesOrganization()
  const {filterContracts: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterContracts({...filter, ...value}))
  }

  React.useEffect(() => {
    try{
      let persisted = JSON.parse(localStorage.getItem('redux-contract-filter') as string)
      if(hasFilterProps(persisted)){
        dispatch(setFilterContracts(persisted))
      }
    }catch(e){}
  }, [])

  return (
    <TRowFilter>
      <td>
        <TextInputV2
          placeholder={t('kontrak-nomor')}
          value={filter?.contract_number ?? ''}
          onChange={({target}) => handleFilterChange({contract_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('SAP Number')}
          value={filter?.sap_number ?? ''}
          onChange={({target}) => handleFilterChange({sap_number: target.value})}
        />
      </td>
      {!isNullRole ? (
        <td>
          <TextInputV2
            placeholder={t('order-pelanggan')}
            value={filter?.customer_name ?? ''}
            onChange={({target}) => handleFilterChange({customer_name: target.value})}
          />
        </td>
      ) : (
        <td>
          <Selection
            placeholder={t('Sales Org')}
            data={salesOrgOptions}
            value={filter?.sales_org_code ?? ''}
            onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
          />
        </td>
      )}
      <td>
        <Selection
          data={REGARDING_OPTIONS}
          placeholder={t('order-prihal')}
          value={filter?.regarding ?? ''}
          onChange={(regarding) => handleFilterChange({regarding})}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          value={filter?.sector_id ?? ''}
          placeholder={t('order-sektor')}
          onChange={(sector_id) => handleFilterChange({sector_id})}
        />
      </td>
      {!isNullRole && (
        <td>
          <Selection
            placeholder={t('Sales Org')}
            data={salesOrgOptions}
            value={filter?.sales_org_code ?? ''}
            onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
          />
        </td>
      )}
      <td>
        <TextInputV2
          placeholder={t('Order Number')}
          value={filter?.po_number ?? ''}
          onChange={({target}) => handleFilterChange({po_number: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('SIP Number')}
          value={filter?.sip_number ?? ''}
          onChange={({target}) => handleFilterChange({sip_number: target.value})}
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('kontrak-tanggal')}
          startDate={filter?.from_date ?? ''}
          endDate={filter?.to_date ?? ''}
          onChange={({startDate, endDate}) =>
            handleFilterChange({
              from_date: startDate.replaceAll('/', '-'),
              to_date: endDate.replaceAll('/', '-'),
            })
          }
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('Start-Date')}
          isSelectsRange={false}
          startDate={filter?.validity_date_from ?? ''}
          onChange={({startDate}) =>
            handleFilterChange({validity_date_from: startDate.replaceAll('/', '-')})
          }
        />
      </td>
      <td>
        <DatePickerV2
          placeholder={t('End-Date')}
          isSelectsRange={false}
          startDate={filter?.validity_date_to ?? ''}
          onChange={({startDate}) =>
            handleFilterChange({validity_date_to: startDate.replaceAll('/', '-')})
          }
        />
      </td>
      <td>
        <Selection
          placeholder={t('sub-order-jenis')}
          data={PRODUCT_TYPE}
          value={filter?.product_type ?? ''}
          onChange={(product_type) => handleFilterChange({product_type})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-kuantum')}
          value={filter?.total_quantum ?? ''}
          onChange={({target}) => handleFilterChange({total_quantum: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('kontrak-harga')}
          value={filter?.grand_total ?? ''}
          onChange={({target}) => handleFilterChange({grand_total: target.value})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Metode Pembayaran')}
          data={PAYMENT_TYPE}
          value={filter?.payment_type ?? ''}
          onChange={(payment_type) => handleFilterChange({payment_type})}
        />
      </td>
      <td>
        <Selection
          placeholder={t('Status')}
          data={
            isNullRole
              ? CONTRACT_STATUS.map((item) =>
                  item.label === 'SAP Error' ? {...item, label: 'Pending'} : item
                )
              : CONTRACT_STATUS
          }
          value={filter?.status ?? ''}
          onChange={(status) => handleFilterChange({status})}
        />
      </td>
      <td>&nbsp;</td>
    </TRowFilter>
  )
}

export default React.memo(RowFilter)
